export interface GuestData {
  coverageEffectiveDate?: string;
  coverageType?: string;
  exchangeId?: string;
  gated?: string;
  language?: string;
  lob?: string;
  ndbLob?: string;
  planId?: string;
  portalSource?: string;
  qhpId?: string;
  stateCode?: string;
  virtualFirst?: string;
  zipCode?: string;
}

export interface GuestState {
  guestData: GuestData;
  setGuestData: (values: GuestData) => void;
  clearGuestData: (defaultValues?: GuestData) => void;
  chooseType: string;
  setChooseType: (chooseType: string) => void;
}

export enum StoreKeys {
  GUEST_DATA = 'guestData',
  SET_GUEST_DATA = 'setGuestData',
  CLEAR_GUEST_DATA = 'clearGuestData',
  CHOOSE_TYPE = 'chooseType',
  SET_CHOOSE_TYPE = 'setChooseType',
}

export const initialState = {
  [StoreKeys.GUEST_DATA]: {},
  [StoreKeys.CHOOSE_TYPE]: '',
};

export const PERSIST_KEYS = [StoreKeys.GUEST_DATA];
